const state = {
  serviceName: window.localStorage.getItem("serviceName"),
  serviceId: window.localStorage.getItem("serviceId")
};
const mutations = {
  setServiceName(state, val) {
    console.log(123);
    state.serviceName = val;
    console.log(state.serviceName);
  },
  setServiceId(state, val) {
    state.serviceId = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
